var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 33C9.7195 32.9909 3.00909 26.2805 3 18V17.7C3.1649 9.45682 9.95188 2.89196 18.196 3.00135C26.4401 3.11073 33.0505 9.85336 32.9967 18.098C32.9428 26.3427 26.2449 32.9984 18 33ZM18 6.00003C11.3726 6.00003 6 11.3726 6 18C6 24.6274 11.3726 30 18 30C24.6274 30 30 24.6274 30 18C29.9926 11.3757 24.6243 6.00747 18 6.00003ZM15.825 25.5L13.704 23.3775L19.0065 18.075L13.704 12.7725L15.825 10.65L23.25 18.075L15.8265 25.5H15.825Z",
    fill: "#0098DB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleChevronRight);
export default __webpack_public_path__ + "static/media/circle_chevron_right.a2411202bd82f1be020b943dc6f65458.svg";
export { ForwardRef as ReactComponent };